<template>
  <div>
    <HeadBanner
      v-if="$store.state.selected_menu"
      :itemData="$store.state.selected_menu"
    />
    <Breadcrumb />
    <div class="container news-media-inner">
      <h1 class="noto-semibold ttl">
        {{ getPost.title }}
      </h1>
      <div class="main">
        <!-- <div class="img-box" style="display: none">
          <picture>
            <source media="(max-width: 767px)" srcset="@/assets/img/1.jpg" />
            <source media="(max-width: 1023px)" srcset="@/assets/img//1.jpg" />
            <img src="@/assets/img/1.jpg" class="img-absolute" alt />
          </picture>
        </div> -->
        <div class="video-box">
          <picture>
            <source
              media="(max-width: 767px)"
              :srcset="_.get(getPost, 'images.0.url')"
            />
            <source
              media="(max-width: 1023px)"
              :srcset="_.get(getPost, 'images.0.url')"
            />
            <img
              :src="_.get(getPost, 'images.0.url')"
              class="img-absolute"
              alt
            />
          </picture>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100.002"
            height="99.999"
            viewBox="0 0 100.002 99.999"
            v-if="_.get(getPost, 'video')"
          >
            <path
              id="Subtraction_136"
              data-name="Subtraction 136"
              d="M-16441,1051a49.691,49.691,0,0,1-19.463-3.929,49.828,49.828,0,0,1-15.895-10.716,49.829,49.829,0,0,1-10.715-15.893A49.662,49.662,0,0,1-16491,1001a49.662,49.662,0,0,1,3.93-19.462,49.829,49.829,0,0,1,10.715-15.893,49.826,49.826,0,0,1,15.895-10.715A49.689,49.689,0,0,1-16441,951a49.689,49.689,0,0,1,19.463,3.929,49.81,49.81,0,0,1,15.893,10.715,49.775,49.775,0,0,1,10.715,15.893A49.662,49.662,0,0,1-16391,1001a49.663,49.663,0,0,1-3.93,19.462,49.777,49.777,0,0,1-10.715,15.893,49.814,49.814,0,0,1-15.893,10.716A49.691,49.691,0,0,1-16441,1051Zm-7.713-66.533a3.008,3.008,0,0,0-3.006,3v27.059a3.008,3.008,0,0,0,3.006,3,2.97,2.97,0,0,0,1.506-.414l23.193-13.529a2.972,2.972,0,0,0,1.488-2.591,2.972,2.972,0,0,0-1.488-2.591l-23.193-13.529A2.945,2.945,0,0,0-16448.711,984.468Z"
              transform="translate(16491 -951.002)"
              fill="#fff"
              opacity="0.8"
            />
          </svg>
          <div class="img-layer"></div>
          <div class="link" id="video-gallery">
            <a
              v-if="_.get(getPost, 'video')"
              :href="_.get(getPost, 'video')"
            ></a>
          </div>
        </div>

        <span class="description" v-if="_.get(getPost, 'newssource')">
          <span class="noto-semibold ttl" v-if="_.get(getPost, 'newssource')">
            {{ _.get(getPost, "newssource") }}</span
          >
          <time class="noto-semibold">
            {{ getPost.updated_at }}
          </time>
        </span>
        <span class="description" v-if="!_.get(getPost, 'newssource')">
          <time class="noto-semibold" style="border-radius: 4px">
            {{ getPost.updated_at }}
          </time>
        </span>

        <div class="text" v-html="getPost.content.tabs[0].content"></div>

        <a
          v-if="_.get(getPost.files, '0.url')"
          :href="_.get(getPost.files, '0.url')"
          target="_blank"
          class="download-btn"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="49.999"
            height="50"
            viewBox="0 0 49.999 50"
          >
            <g
              id="Group_1356"
              data-name="Group 1356"
              transform="translate(-0.239 -0.001)"
            >
              <path
                id="Subtraction_27"
                data-name="Subtraction 27"
                d="M25,50c-9.766,0-15.8-1.672-19.555-5.422S0,34.781,0,25A43.882,43.882,0,0,1,1.3,13.288,17.089,17.089,0,0,1,5.561,5.562,17.089,17.089,0,0,1,13.287,1.3,43.882,43.882,0,0,1,25,0C34.78,0,40.818,1.68,44.576,5.446S50,15.234,50,25c0,9.79-1.672,15.827-5.422,19.577S34.789,50,25,50ZM19.552,31.728v3.088H30.433V31.728Zm-.673-10.907a.873.873,0,0,0-.621,1.49L24.4,28.419a.888.888,0,0,0,1.237,0l6.141-6.108a.872.872,0,0,0-.621-1.49H27.648V15.866A.873.873,0,0,0,26.771,15H23.263a.871.871,0,0,0-.875.866v4.955Z"
                transform="translate(0.24 0.001)"
                fill="#444958"
              />
            </g>
          </svg>

          <span class="noto-semibold">{{
            $fn.tr("Downloan Press Releases")
          }}</span>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="5.844"
            height="9.566"
            viewBox="0 0 5.844 9.566"
          >
            <g
              id="Group_1006"
              data-name="Group 1006"
              transform="translate(42.561 -19638.994) rotate(-90)"
            >
              <path
                id="Path_61"
                data-name="Path 61"
                d="M0,3.722,3.722,0"
                transform="translate(-19643.777 -41.5)"
                fill="none"
                stroke="#444958"
                stroke-linecap="round"
                stroke-width="1.5"
              />
              <path
                id="Path_60"
                data-name="Path 60"
                d="M3.722,3.722,0,0"
                transform="translate(-19647.5 -41.5)"
                fill="none"
                stroke="#444958"
                stroke-linecap="round"
                stroke-width="1.5"
              />
            </g>
          </svg>
        </a>
      </div>

      <!-- {{ getPost }} -->

      <div class="left">
        <h3 class="noto-semibold ttl">Other News & Media</h3>

        <router-link
          :to="$store.getters.getSingleUrl(post, 1)"
          v-for="post in getRelatedSearch"
          :key="post.id"
          class="media-small-box"
        >
          <div class="img-box" v-if="_.get(post, 'images.0.url')">
            <picture>
              <source
                media="(max-width: 767px)"
                :srcset="_.get(post, 'images.0.url')"
              />
              <source
                media="(max-width: 1023px)"
                :srcset="_.get(post, 'images.0.url')"
              />
              <img
                :src="_.get(post, 'images.0.url')"
                class="img-absolute"
                alt
              />
            </picture>
            <div class="img-layer"></div>
          </div>

          <h2 class="noto-semibold ttl">
            {{ post.title }}
          </h2>
          <div class="txt">
            {{ post.teaser }}
          </div>
        </router-link>

        <div class="search-wrap">
          <input
            type="text"
            class="c-input"
            placeholder="Search by keyword"
            v-model="searchByKey"
          />
          <button>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24.998"
              height="24.998"
              viewBox="0 0 24.998 24.998"
            >
              <g
                id="Group_1309"
                data-name="Group 1309"
                transform="translate(19679.999 90.998)"
              >
                <path
                  id="Subtraction_52"
                  data-name="Subtraction 52"
                  d="M1300.5,21229c-4.882,0-7.9-.836-9.776-2.711s-2.723-4.9-2.723-9.787c0-4.8.858-7.8,2.781-9.721s4.919-2.779,9.718-2.779c4.892,0,7.91.84,9.788,2.723s2.711,4.893,2.711,9.777-.836,7.912-2.711,9.787S1305.394,21229,1300.5,21229Zm1.662-9.5v0l2.274,2.736.054.059a1.28,1.28,0,1,0,1.747-1.863l-2.738-2.27a5.217,5.217,0,1,0-1.338,1.338Zm-2.936-.441a3.842,3.842,0,1,1,3.847-3.836A3.848,3.848,0,0,1,1299.227,21219.059Z"
                  transform="translate(-20968 -21295)"
                  fill="#444958"
                />
              </g>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AliMixin from "@/mixins/ali";
import Breadcrumb from "@/components/Breadcrumb";
import HeadBanner from "@/components/HeadBanner";
import moment from "moment";

export default {
  components: {
    Breadcrumb,
    HeadBanner
  },

  data() {
    return {
      searchByKey: ""
    };
  },

  computed: {
    getPost() {
      if (_.get(this.$store.state.current_content, "primary") !== undefined) {
        const data = _.get(this.$store.state.current_content, "primary")[0];
        data.updated_at = moment(data.updated_at).format("DD MM YYYY");
        return data;
      }
    },

    getRelatedSearch() {
      if (
        _.get(
          this.$store.state.current_content,
          "secondary.NewsMediaBlock.data"
        ) !== undefined
      ) {
        const data = _.get(
          this.$store.state.current_content,
          "secondary.NewsMediaBlock.data"
        ).slice(0, 2);
        return data.filter(
          item =>
            item.title.toLowerCase().indexOf(this.searchByKey.toLowerCase()) !==
            -1
        );
      }
    }
  },

  mixins: [AliMixin],
  mounted() {
    this.startLightGallery();
    // console.log(this.$route.params)
  }
};
</script>
